var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_vm._v("Loading...")]) : [_c('Status', {
    staticClass: "s-text-secondary s-mb-6",
    attrs: {
      "icon": "check",
      "message": "跟團成功！"
    }
  }), _c('div', {
    staticClass: "s-mb-3 s-space-y-3 s-text-center"
  }, [_c('DescriptionList', {
    attrs: {
      "title": "商品名稱"
    }
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('DescriptionList', {
    attrs: {
      "title": "款式"
    }
  }, [_vm._v(_vm._s(_vm.spec.sku_name))])], 1), _c('p', {
    staticClass: "s-text-center s-text-gray s-mb-10"
  }, [_vm._v("團購 ID：" + _vm._s(_vm.groupBuying.groupbuying_number))]), _c('div', {
    staticClass: "s-border s-border-gray-light s-rounded-lg s-px-2 s-py-3"
  }, [_c('p', {
    staticClass: "s-text-center s-text-secondary s-mb-3"
  }, [_c('CautionIcon')], 1), _vm._m(0)])]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v("請注意：跟團成功不等同完成購買，請密切留意成團訊息，"), _c('span', {
    staticClass: "s-text-secondary"
  }, [_vm._v("並在成團後儘速完成結帳")]), _vm._v("，系統才會為您安排出貨喔！")]);
}]

export { render, staticRenderFns }